module.exports = __webpack_public_path__ + "static/media/20ECE15.a0d3b0fb.jpg";